/**
 * Job payment-method display + option helpers for Admin Panel (T2-6868).
 * Labels match PostJob.utils paymentMethodOpts (not legacy convertPaymentMethod).
 */

export type PaymentMethodOption = { id: number; text: string };

export const EDITABLE_PAYMENT_METHOD_STATUSES = [1, 2, 3];

export function isPaymentMethodEditable(status: number | null | undefined): boolean {
  return EDITABLE_PAYMENT_METHOD_STATUSES.includes(Number(status));
}

export function paymentMethodOpts(
  country: number | null | undefined,
  isCentralBooked: number | null | undefined = 0
): PaymentMethodOption[] {
  if (Number(isCentralBooked) === 2) {
    return [{ id: 1, text: "Pay Now (TempStars' Payment Processor)" }];
  }
  return [
    { id: 1, text: "Pay Now (TempStars' Payment Processor)" },
    { id: 2, text: Number(country) === 0 ? "Cheque" : "Check" },
    { id: 3, text: "Electronic Funds Transfer" },
    { id: 4, text: "Payroll / Temporary Employee" }
  ];
}

export function formatJobPaymentMethod(
  paymentMethod: number | null | undefined,
  country: number | null | undefined
): string {
  if (paymentMethod === null || paymentMethod === undefined) {
    return "Not set";
  }
  const match = paymentMethodOpts(country, 0).find(
    o => o.id === Number(paymentMethod)
  );
  return match ? match.text : `Unknown (${paymentMethod})`;
}
